import BaseService from './baseService';

class VideoService {

    static getVideo(videoID) {    
        return BaseService.getAndReturn(`/Videos/${videoID}`, BaseService.returnAssignedObject, 'Unable to fetch video', true);
    }

    static getCharts() {    
        return BaseService.getAndReturn('/Chart/Videos', BaseService.returnAssignedArray, 'Unable to fetch charts', true);
    }

    static playVideo(videoID) {
        let data = '';
        let currentRoleID = '';
        return BaseService.postAndReturn(`/Videos/${videoID}/Play?currentRoleID=${currentRoleID}`, data, (data) => data, 'Unable to play video', true);
    } 
    
    static increaseRating(trackID, currentProfileID) {
        return BaseService.postAndReturn(`/Videos/${trackID}/Ratings?currentProfileID=${currentProfileID}`, {}, BaseService.returnAssignedObject, 'Unable to rate video', true);
    }

    static decreaseRating(trackID, currentProfileID) {
        return BaseService.deleteAndReturn(`/Videos/${trackID}/Ratings?currentProfileID=${currentProfileID}`, {}, BaseService.returnAssignedObject, 'Unable to remove video rating', true);
    }
}
export default VideoService;